export const settingsNavList = [
  {
    title: "Allgemein",
    path: "/dashboard/settings/tenant/general",
    icon: "mdi:company",
    role: "Admin",
  },
  {
    title: "Banking",
    path: "/dashboard/settings/banking",
    icon: "fa-solid:file-invoice-dollar",
    role: "Admin",
  },
  {
    title: "Module",
    path: "/dashboard/settings/modules",
    icon: "mdi:extension",
    role: "Admin",
  },
  {
    title: "Abrechnung",
    path: "/dashboard/settings/payment",
    icon: "material-symbols:payments",
    role: "Admin",
  },
  {
    title: "Benachrichtigungen",
    path: "/dashboard/settings/notifications",
    icon: "mdi:notifications",
  },
  {
    title: "E-Mail",
    path: "/dashboard/settings/mail",
    icon: "ic:baseline-email",
    role: "Admin",
  },
  {
    title: "Shop-Versand",
    path: "/dashboard/settings/shop-delivery",
    icon: "mdi:truck-delivery",
    role: "Admin",
  },
  {
    title: "Rollen-Vorschau",
    path: "/dashboard/settings/role-preview",
    icon: "mdi:eye-outline",
    role: "Admin",
  },
  {
    title: "Passwort ändern",
    path: "/dashboard/settings/password",
    icon: "mdi:password",
  },
  {
    title: "FAQs",
    path: "/dashboard/settings/faq",
    icon: "line-md:question",
  },
];
